import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'underscore';

class Sync extends React.Component {
  componentDidMount() {
    this.initializeSelect2Plugin();
    this.updateSelect2Id();
  }

  componentDidUpdate() {
    this.updateSelect2Id();
  }

  updateSelect2Id() {
    var defaultValue = this.props.node.get(this.props.uniqueNameField);
    if (defaultValue) {
      var selection = _.find(this._convertValues(), function(obj) {
        return obj.id.toString().toLowerCase() === defaultValue.toString().toLowerCase();
      });

      if (selection) {
        $(this.selectInput).val(selection.id).trigger('change');
      }
    }
  }

  render() {
    return (
      <select
        className="select2 select2-initial"
        ref={input => {
          this.selectInput = input;
          this.props.setInput(input);
        }}
      />
    );
  }

  initializeSelect2Plugin() {
    const { placeholderText, width, allowSearch } = this.props;

    const options = {
      data: this._filteredDataWithSelection(this._convertValues(), this.props.placeholderText),
      placeholder: placeholderText,
      width,
      allowClear: false,
      minimumResultsForSearch: allowSearch ? undefined : -1,
      theme: 'bootstrap'
    };

    $(this.selectInput).select2(options);
  }

  // allow for simple lists like ['mobile', 'landline']
  //  and convert to id/text objects
  // If an array of objects is provided they are left alone
  //  and must conform to Select2 plugin format
  _convertValues() {
    return (
      _.map(this.props.values, function(value) {
        if (_.isObject(value)) {
          return value;
        } else {
          return { id: value, text: value };
        }
      })
    );
  }

  _filteredDataWithSelection(data, placeholder) {
    const newData = _.compact(_.clone(data).map(row => {
      // handle grouped data
      if (row.children) {
        return _.extend({}, row, { children: row.children.map(row => this._filteredRowWithSelection(row)) });
      } else {
        return this._filteredRowWithSelection(row);
      }
    }));

    if (placeholder && (!newData[0] || newData[0].id !== '')) {
      newData.unshift({ id: '', text: '' });
    }

    return newData;
  }

  _filteredRowWithSelection(row) {
    if (typeof (row.presence) === "function" && !row.presence.call(this, this.props.node)) {
      return null;
    } else if (row.id && row.id === this.props.node.get(this.props.uniqueNameField)) {
      return _.extend({}, row, { selected: true });
    } else {
      return row;
    }
  }
}

Sync.propTypes = {
  // Required
  friendlyNameField: PropTypes.string.isRequired, // I.e. id_from_network
  uniqueNameField: PropTypes.string.isRequired, // I.e. id
  node: PropTypes.object.isRequired,
  setInput: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired, // For static lists, the complete list of values

  // Optional
  allowSearch: PropTypes.bool,
  width: PropTypes.string,
  placeholderText: PropTypes.string
};

export default Sync;
